import * as loadingState from '../constants/loadingState';

export const FETCH_DISTRICTS = 'FETCH_DISTRICTS';
export const FETCH_DISTRICTS_SUCCESS = 'FETCH_DISTRICTS_SUCCESS';
export const FETCH_DISTRICTS_FAILED = 'FETCH_DISTRICTS_FAILED';

export const FETCH_STUDENT_DISTRICTS = 'FETCH_STUDENT_DISTRICTS';

export const STORE_PREFETCHED_DISTRICT = 'STORE_PREFETCHED_DISTRICT';

/**
 * @param {Object} [country]
 * @param {Bool} [prefetchSchool] Flag indicating prefetching school of the first district.
 */
export const fetchDistricts = ({ country, prefetchSchool, role }) => ({
  type: FETCH_DISTRICTS,
  payload: {
    country,
    prefetchSchool,
    role,
  },
});

export const fetchDistrictsSuccess = data => ({
  type: FETCH_DISTRICTS_SUCCESS,
  payload: {
    data,
  },
});

export const fetchDistrictsFailed = errorMessage => ({
  type: FETCH_DISTRICTS_FAILED,
  payload: {
    errorMessage,
  },
});

export const storePrefetchedDistrict = district => ({
  type: STORE_PREFETCHED_DISTRICT,
  payload: {
    district,
  },
});

export const fetchStudentDistricts = country => ({
  type: FETCH_STUDENT_DISTRICTS,
  payload: {
    country,
  },
});

const INIT_STATE = {
  data: [],
  prefetchedDistrict: {},
  loadingStatus: loadingState.EMPTY,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_DISTRICTS:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case FETCH_DISTRICTS_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        data: action.payload.data,
      };
    case FETCH_DISTRICTS_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
      };
    case STORE_PREFETCHED_DISTRICT:
      return {
        ...state,
        prefetchedDistrict: action.payload.district,
      };
    case FETCH_STUDENT_DISTRICTS:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    default:
      return state;
  }
};

export default reducer;

export const getDistricts = state => state.district.data;



// WEBPACK FOOTER //
// ./app/redux/district.js